import React from 'react';
import cx from 'classnames';
import pick from 'lodash/pick';
import ContentIcon from '../ContentIcon/index.js';
import ContentTile from '../ContentTile/index.js';
import ElementSize from '../ElementSize/index.js';
import UnitList from '../UnitList/index.js';
import ContentBadges from '../lib/ContentBadges.js';
import ContentButtons from '../lib/ContentButtons.js';
import ContentInformation from '../lib/ContentInformation.js';
import ContentPreviewIndicator from '../lib/ContentPreviewIndicator.js';
import ContentProgress from '../lib/ContentProgress.js';
import contentType, { defaultContentType } from '../lib/types/content.js';
import CredentialRegistrationButton from '../lib/CredentialRegistrationButton.js';
import CustomStepButton from '../lib/CustomStepButton.js';
import labelsForUnitList from '../lib/labelsForUnitList.js';
import withAutomaticColorCalculation from '../lib/withAutomaticColorCalculation.js';

const InternalContentBrick = ({
  buttons,
  className,
  content,
  credential,
  eventHandlers,
  labels,
  trackEvent,
  user,
  units,
  unitsInitiallyExpanded
}) => /*#__PURE__*/React.createElement("div", {
  style: {
    borderTopColor: content.color
  },
  className: cx(className, "tds-content-panel slds-text-body_small tds-color_meteorite slds-is-relative slds-wrap")
}, /*#__PURE__*/React.createElement("div", {
  className: cx("slds-grid tds-content-panel_body", {
    "slds-border_bottom": units
  })
}, content.preview && /*#__PURE__*/React.createElement(ContentPreviewIndicator, {
  labels: labels,
  id: content.apiName,
  namespace: content.preview.namespace,
  releasedAt: content.preview.releasedAt,
  updatedAt: content.preview.updatedAt
}), /*#__PURE__*/React.createElement("div", {
  className: "slds-grow-none slds-shrink-none"
}, /*#__PURE__*/React.createElement(ContentIcon, {
  content: {
    ...pick(content, ["color", "image", "path", "trailmix", "type", "unitCount"])
  },
  user: pick(user, ["finishedAt", "unlocked", "completedCount"]),
  noLink: content.path == null || content.path === "",
  trackEvent: trackEvent,
  onClick: eventHandlers.onIconClick
})), /*#__PURE__*/React.createElement("div", {
  className: "slds-grow slds-m-left_large"
}, /*#__PURE__*/React.createElement("div", {
  className: "slds-float_right"
}, /*#__PURE__*/React.createElement(ContentBadges, {
  content: content,
  user: user,
  labels: labels,
  horizontal: true
})), /*#__PURE__*/React.createElement(ContentInformation, {
  content: content,
  className: "slds-m-top_x-small",
  noLink: content.path == null || content.path === "",
  trackEvent: trackEvent,
  onTitleClick: eventHandlers.onTitleClick
}), /*#__PURE__*/React.createElement("div", {
  className: cx("slds-grid", "slds-m-top_medium", {
    "slds-grid_align-end": content.type === "customstep"
  }),
  style: {
    minHeight: "2.5rem"
  }
}, /*#__PURE__*/React.createElement("div", {
  className: "slds-grow tds-content__buttons"
}, buttons && /*#__PURE__*/React.createElement(ContentButtons, {
  buttons: buttons
})), /*#__PURE__*/React.createElement("div", {
  className: "slds-grow-none slds-grid slds-grid_vertical-align-center slds-text-align_right"
}, content.type === "credential" && /*#__PURE__*/React.createElement(CredentialRegistrationButton, {
  credential: credential,
  labels: labels
}), content.type !== "credential" && /*#__PURE__*/React.createElement(ContentProgress, {
  content: content,
  user: user,
  labels: labels
}), content.type === "customstep" && content.manualCompletion === true && /*#__PURE__*/React.createElement(CustomStepButton, {
  completedOn: user && user.finishedAt,
  markAsCompleteLabel: labels.markAsComplete,
  buttonLabel: labels.buttonLabel,
  clickHandler: eventHandlers && eventHandlers.completeCustomStepHandler
}))))), units && /*#__PURE__*/React.createElement(UnitList, {
  className: "tds-bg_white",
  units: units,
  initiallyCollapsed: !unitsInitiallyExpanded,
  labels: labelsForUnitList(content.type, labels),
  collapsible: true,
  parentApiName: content.apiName
}));
InternalContentBrick.displayName = "InternalContentBrick";
InternalContentBrick.propTypes = contentType;
InternalContentBrick.defaultProps = defaultContentType;
const WrappedContentBrick = withAutomaticColorCalculation(InternalContentBrick);
const ContentBrickContainer = props => /*#__PURE__*/React.createElement(ElementSize, null, ({
  width
}) => {
  if (!width || width > 640) {
    return /*#__PURE__*/React.createElement(WrappedContentBrick, props);
  }
  return /*#__PURE__*/React.createElement(ContentTile, props);
});
ContentBrickContainer.displayName = "ContentBrickContainer";
ContentBrickContainer.propTypes = contentType;
ContentBrickContainer.defaultProps = defaultContentType;
var ContentBrickContainer$1 = ContentBrickContainer;

export { InternalContentBrick, WrappedContentBrick, ContentBrickContainer$1 as default };
